import styled from "styled-components";

export const Container = styled.tr`
  height: 50px;
`;
